import React, { useState } from 'react';
import {
  Button,
  Card,
  Col,
  Dropdown,
  Form,
  Image,
  Modal,
  Row
} from 'react-bootstrap';
// import { customersData } from 'data/ecommerce/customersData';
import CardDropdown from 'components/common/CardDropdown';
import Flex from 'components/common/Flex';
import DocumentTableHeader from './DocumentTableHeader';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import useAdvanceTable from 'hooks/useAdvanceTable';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import SubtleBadge from 'components/common/SubtleBadge';
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { optionsDoc } from 'nursd-dashboard/data/defaultData';
import makeAnimated from 'react-select/animated';
import DatePicker from 'react-datepicker';
import UploadImage from './UploadImage';
import UploadFile from './UploadFile';
import UploadMultiImages from './UploadMultiImages';
import { socket } from 'nursd-dashboard/api/socket';
import { v4 as uuidv4 } from 'uuid';
import { useAuth } from 'nursd-dashboard/context/AuthContext';
import { postDocument, updateDocument } from 'nursd-dashboard/api/documents';
import { uploadFile } from 'nursd-dashboard/utils/AWSHelper';
import { getNurseDetails } from 'nursd-dashboard/api/nurseTable';
import { useEffect } from 'react';
import { postNurseNotification } from 'nursd-dashboard/api/nurseNotification';
import { sendNotification } from 'nursd-dashboard/api/webNotification';
import { toast } from 'react-toastify';

const DocumentTable = ({ documentData, nurseId, refresh, setRefresh }) => {
  const [viewImg, setViewImg] = useState('');
  const [viewImgModel, setViewImgModel] = useState(false);

  const columns = [
    {
      accessorKey: 'type',
      header: 'Document Type',
      enableSorting: false,
      meta: {
        headerProps: { className: 'text-900' },
        cellProps: { className: '' }
      },
      cell: ({ row: { original } }) => {
        const { type } = original;
        return <p className="pt-2">{type}</p>;
      }
    },
    {
      accessorKey: 'type',
      header: 'Document',
      enableSorting: false,
      meta: {
        headerProps: { className: 'text-900' },
        cellProps: { className: '' }
      },
      cell: ({ row: { original } }) => {
        const { frontImage, backImage, multipleImages, file } = original;
        return (
          <Flex direction="row" className="pt-2">
            {file !== '' && (
              <p
                className="px-1"
                onClick={() => window.open(file, '_blank')}
                style={{
                  cursor: 'pointer'
                }}
              >
                File
                <FontAwesomeIcon
                  icon={'download'}
                  className="mx-2 text-primary"
                />
              </p>
            )}
            {frontImage !== '' && (
              <p
                className="px-1"
                style={{
                  cursor: 'pointer'
                }}
              >
                Front Side
                <FontAwesomeIcon
                  icon={'download'}
                  className="mx-2 text-primary"
                  onClick={() => window.open(frontImage, '_blank')}
                />
                <FontAwesomeIcon
                  icon={'eye'}
                  className="mx-2 text-primary"
                  onClick={() => {
                    setViewImg(frontImage);
                    setViewImgModel(true);
                  }}
                />
              </p>
            )}
            {backImage !== '' && (
              <p
                className="px-1"
                style={{
                  cursor: 'pointer'
                }}
              >
                Back Side
                <FontAwesomeIcon
                  icon={'download'}
                  className="mx-2 text-primary"
                  onClick={() => window.open(backImage, '_blank')}
                />
                <FontAwesomeIcon
                  icon={'eye'}
                  className="mx-2 text-primary"
                  onClick={() => {
                    setViewImg(backImage);
                    setViewImgModel(true);
                  }}
                />
              </p>
            )}
            {multipleImages?.length !== 0 && (
              <>
                <p className="px-1">Images</p>
                {multipleImages?.map((item, index) => {
                  return (
                    <p
                      className="px-1"
                      key={index}
                      style={{
                        cursor: 'pointer'
                      }}
                    >
                      <FontAwesomeIcon
                        icon={'download'}
                        className="mx-2 text-primary"
                        onClick={() => window.open(item, '_blank')}
                      />
                      <FontAwesomeIcon
                        icon={'eye'}
                        className="mx-2 text-primary"
                        onClick={() => {
                          setViewImg(item);
                          setViewImgModel(true);
                        }}
                      />
                    </p>
                  );
                })}
              </>
            )}
          </Flex>
        );
      }
    },
    {
      accessorKey: 'document_status',
      header: 'Status',
      enableSorting: false,
      meta: {
        headerProps: { className: 'text-900' },
        cellProps: { className: '' }
      },
      cell: ({ row: { original } }) => {
        const { document_status } = original;
        return (
          <SubtleBadge
            pill
            bg={
              document_status === 'waiting'
                ? 'primary'
                : document_status === 'Approved'
                ? 'success'
                : document_status === 'Not Approved'
                ? 'danger'
                : 'primary'
            }
          >
            {document_status}
          </SubtleBadge>
        );
      }
    },
    {
      accessorKey: 'createdAt',
      header: 'Submitted',
      enableSorting: false,
      meta: {
        headerProps: { className: 'text-900' },
        cellProps: { className: '' }
      },
      cell: ({ row: { original } }) => {
        const { createdAt } = original;
        return <p>{moment(createdAt).format('DD MMM,YYYY hh:mm a')}</p>;
      }
    },
    {
      accessorKey: 'expiration_date',
      header: 'Expiration',
      enableSorting: false,
      meta: {
        headerProps: { className: 'text-900' },
        cellProps: { className: '' }
      },
      cell: ({ row: { original } }) => {
        const { expiration_date } = original;
        return <p>{moment(expiration_date).format('DD MMM,YYYY')}</p>;
      }
    },
    {
      accessorKey: 'none',
      header: '',
      enableSorting: false,
      meta: {
        cellProps: {
          className: 'text-end'
        }
      },
      cell: ({ row: { original } }) => {
        const { document_status } = original;
        return (
          <div>
            {document_status !== 'Approved' && (
              <CardDropdown>
                <div className="py-2">
                  <Dropdown.Item>Approver</Dropdown.Item>
                  <Dropdown.Item>Not Approved</Dropdown.Item>
                </div>
              </CardDropdown>
            )}
          </div>
        );
      }
    }
  ];

  const table = useAdvanceTable({
    data: documentData,
    columns,
    selection: true,
    sortable: true,
    pagination: true,
    perPage: 10
  });

  const { authToken } = useAuth();
  const [nurse, setNurse] = useState(undefined);
  const [loadingScreen, setLoadingScreen] = useState(true);
  const [uploadDoc, setUploadDoc] = useState(false);
  const [valueDocType, setValueDocType] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    date: new Date(),
    issueBody: '',
    comments: ''
  });

  const animatedComponents = makeAnimated();

  const [loading, setLoading] = React.useState(false);
  const [fileDoc, setFileDoc] = React.useState([]);
  const [filesFront, setFilesFront] = React.useState([]);
  const [filesBack, setFilesBack] = React.useState([]);
  const [files, setFiles] = useState([]);

  const handleChange = ({ target }) => {
    let name = target.name;
    let value = target.value;
    setFormData({ ...formData, [name]: value });
  };

  const handleClose = () => {
    setValueDocType(null);
    setFormData({ name: '', date: new Date(), issueBody: '' });
    setUploadDoc(false);
    setFileDoc([]);
    setFilesFront([]);
    setFilesBack([]);
    setFiles([]);
  };

  const handleRemoveFront = path => {
    setFilesFront(filesFront.filter(file => file.path !== path));
  };

  const handleRemoveBack = path => {
    setFilesBack(filesBack.filter(file => file.path !== path));
  };

  const handleRemoveDoc = path => {
    setFileDoc(fileDoc.filter(file => file.path !== path));
  };

  const handleRemove = path => {
    const filteredFiles = files.filter(file => file.path !== path);
    setFiles(filteredFiles);
  };

  const postData = async (keyFront, keyBack, imageArr, file) => {
    try {
      await postDocument(
        authToken,
        valueDocType?.label,
        formData?.name,
        formData?.issueBody,
        formData?.date.toString(),
        keyFront,
        keyBack,
        imageArr,
        '',
        file,
        Number(nurseId)
      ).then(async res => {
        await updateDocument(authToken, res?.id, {
          document_status: 'Approved',
          verified: true,
          reviewerComments: formData?.comments
        })
          .then(async () => {
            await postNurseNotification(
              authToken,
              Number(nurseId),
              '',
              'Document Uploaded',
              `Your Document is uploaded by admin`,
              'MyDocumentsScreen',
              {},
              false,
              false,
              'green',
              ''
            );
            socket?.emit('tableNotificationInsert', {
              table: 'NurseNotificationTable',
              id: Number(nurseId)
            });
            if (nurse?.mobileId) {
              sendNotification(authToken, {
                expoPushToken: nurse?.mobileId,
                title: 'Document Uploaded',
                body: `Your Document is uploaded by admin`,
                data: { screen: 'MyDocumentsScreen' }
              });
            }
            toast.success(`Successfully uploaded the document.`, {
              theme: 'colored'
            });
            setRefresh(!refresh);
            setValueDocType(null);
            setFormData({
              name: '',
              date: new Date(),
              issueBody: '',
              comments: ''
            });
            setUploadDoc(false);
            setFileDoc([]);
            setFilesFront([]);
            setFilesBack([]);
            setFiles([]);
          })
          .catch(e => {
            console.log(e);
          });
      });
    } catch (error) {
      console.log(error);
    }
  };

  const getBlob = async uri => {
    const response = await fetch(uri);
    const blob = await response.blob();
    return blob;
  };

  const blobToUint8Array = blob => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const uint8Array = new Uint8Array(reader.result);
        resolve(uint8Array);
      };
      reader.onerror = reject;
      reader.readAsArrayBuffer(blob);
    });
  };

  // Function to get the Uint8Array from the file
  const getFileAsUint8Array = async file => {
    const uri = file.preview; // Get the URI from the file's preview property
    const blob = await getBlob(uri); // Convert URI to Blob
    const uint8Array = await blobToUint8Array(blob); // Convert Blob to Uint8Array
    return uint8Array;
  };

  // Example usage: After a file is dropped, convert it to Uint8Array
  const handleConvert = async file => {
    if (file && file[0]) {
      const uint8Array = await getFileAsUint8Array(file[0]);
      return uint8Array; // Do something with the Uint8Array
    }
  };

  const handleConvertObj = async file => {
    const uint8Array = await getFileAsUint8Array(file);
    return uint8Array; // Do something with the Uint8Array
  };

  const postNurseDocument = async () => {
    if (
      valueDocType?.label === 'Assessment' ||
      valueDocType?.label === 'Health Document' ||
      valueDocType?.label === 'Misc Documents'
    ) {
      setLoading(true);

      if (files.length > 0) {
        let imageArr = [];
        await Promise.all(
          files.map(async item => {
            // const blobItem = await getBlob(item);
            // const bufferItem = await blobToUint8Array(blobItem);
            const bufferItem = await handleConvertObj(item);

            let nameItem = `${nurse?.uniqueId}/documents-${uuidv4()}.png`;
            // console.log(buffer, name)
            const keyItem = await uploadFile(
              authToken,
              nameItem,
              bufferItem,
              ''
            );
            imageArr.push(keyItem.key);
          })
        );
        if (fileDoc.length !== 0) {
          // const blob = await getBlob(fileDoc);
          // const buffer = await blobToUint8Array(blob);
          const buffer = await handleConvert(fileDoc);

          let name = `${nurse?.uniqueId}/documents-${uuidv4()}.pdf`;
          // console.log(buffer, name)
          const key = await uploadFile(authToken, name, buffer, '');

          if (files.length === imageArr.length) {
            postData('', '', imageArr, key?.key);
          }
        } else {
          if (files.length === imageArr.length) {
            postData('', '', imageArr, '');
          }
        }
      } else {
        if (fileDoc.length !== 0) {
          // const blob = await getBlob(fileDoc);
          // const buffer = await blobToUint8Array(blob);
          const buffer = await handleConvert(fileDoc);

          let name = `${nurse?.uniqueId}/documents-${uuidv4()}.pdf`;
          // console.log(buffer, name)
          const key = await uploadFile(authToken, name, buffer, '');
          postData('', '', [], key?.key);
        } else {
          postData('', '', [], '');
        }
      }
    } else {
      setLoading(true);
      // const blobFront = await getBlob(filesFront);
      // const bufferFront = await blobToUint8Array(blobFront);
      if (filesFront.length !== 0 && filesBack.length !== 0) {
        const bufferFront = await handleConvert(filesFront);

        let nameFront = `${nurse?.uniqueId}/documents-${uuidv4()}.png`;
        // console.log(buffer, name)
        const keyFront = await uploadFile(
          authToken,
          nameFront,
          bufferFront,
          ''
        );

        // const blobBack = await getBlob(filesBack);
        // const bufferBack = await blobToUint8Array(blobBack);
        const bufferBack = await handleConvert(filesBack);

        let nameBack = `${nurse?.uniqueId}/documents-${uuidv4()}.png`;
        // console.log(buffer, name)
        const keyBack = await uploadFile(authToken, nameBack, bufferBack, '');

        if (keyFront.key !== '' && keyBack.key !== '') {
          postData(keyFront.key, keyBack.key, [], '');
        }
      } else {
        setLoading(false);
        toast.warning(
          `Upload both front and back images to submit successfully.`,
          {
            theme: 'colored'
          }
        );
      }
    }
  };

  const checkUser = async (authToken, id) => {
    try {
      await getNurseDetails(authToken, id).then(res => {
        if (res === undefined) {
          setNurse(null);
          setLoadingScreen(false);
        } else {
          setNurse(res);
          setLoadingScreen(false);
        }
      });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (nurseId !== null) {
      checkUser(authToken, nurseId);
    }
  }, [nurseId]);

  const handleSubmit = event => {
    event.preventDefault(); // Prevent default form submission behavior
    postNurseDocument();
  };

  const handleCloseView = () => {
    setViewImgModel(false);
    setViewImg('');
  };

  return (
    <>
      {loadingScreen ? (
        <p className="mt-2">Loading...</p>
      ) : (
        <AdvanceTableProvider {...table}>
          <Card className="mb-3">
            <Card.Header>
              <DocumentTableHeader
                document={documentData}
                uploadDoc={uploadDoc}
                setUploadDoc={setUploadDoc}
              />
            </Card.Header>
            {uploadDoc ? (
              <div>
                <Form onSubmit={handleSubmit}>
                  <div className="p-x1">
                    <Row className="mb-2" style={{ marginTop: -20 }}>
                      <Form.Group
                        as={Col}
                        md="12"
                        className="mb-2"
                        controlId="DocumentType"
                      >
                        <Form.Label className="fs-9">Document Type</Form.Label>
                        <Select
                          className="basic-single"
                          classNamePrefix="select"
                          placeholder="Select..."
                          isClearable
                          isSearchable
                          name="color"
                          value={valueDocType}
                          onChange={value => {
                            setValueDocType(value);
                          }}
                          options={optionsDoc}
                          components={animatedComponents}
                          required
                        />
                      </Form.Group>
                    </Row>
                    <Row className="mb-2">
                      <Form.Group
                        as={Col}
                        md="6"
                        className="mb-2"
                        controlId="name"
                      >
                        <Form.Label className="fs-9">Document Name</Form.Label>
                        <Form.Control
                          type="text"
                          name="name"
                          placeholder="Name"
                          required
                          value={formData?.name}
                          onChange={handleChange}
                        />
                      </Form.Group>
                      <Form.Group
                        as={Col}
                        md="6"
                        className="mb-2"
                        controlId="date"
                      >
                        <Form.Label className="fs-9">
                          Date of Expiration
                        </Form.Label>
                        <DatePicker
                          selected={formData.date}
                          onChange={v => {
                            setFormData({
                              ...formData,
                              date: v
                            });
                          }}
                          className="form-control"
                          placeholderText="MM-DD-YYYY"
                          dateFormat="MM-dd-yyyy"
                        />
                      </Form.Group>
                    </Row>
                    {valueDocType?.label !== 'Misc Documents' ? (
                      <Form.Group className="mb-2" controlId="issueBody">
                        <Form.Label className="fs-9">Issuing Body</Form.Label>
                        <Form.Control
                          required
                          as="textarea"
                          rows={3}
                          name="issueBody"
                          onChange={handleChange}
                        />
                      </Form.Group>
                    ) : (
                      <Form.Group className="mb-2" controlId="issueBody">
                        <Form.Label className="fs-9">
                          Submission Notes
                        </Form.Label>
                        <Form.Control
                          required
                          as="textarea"
                          rows={3}
                          name="issueBody"
                          onChange={handleChange}
                        />
                      </Form.Group>
                    )}
                    <Form.Group className="mb-2" controlId="comments">
                      <Form.Label className="fs-9">Comments</Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={3}
                        name="comments"
                        onChange={handleChange}
                      />
                    </Form.Group>
                    {(valueDocType?.label === 'Background & ID' ||
                      valueDocType?.label === 'License' ||
                      valueDocType?.label === 'Certification') && (
                      <Flex justifyContent={'between'} className={'mx-3'}>
                        <Col md="5">
                          <UploadImage
                            file={filesFront}
                            setFile={setFilesFront}
                            handleRemove={handleRemoveFront}
                            name={'front'}
                          />
                        </Col>
                        <Col md="5">
                          <UploadImage
                            file={filesBack}
                            setFile={setFilesBack}
                            handleRemove={handleRemoveBack}
                            name={'back'}
                          />
                        </Col>
                      </Flex>
                    )}

                    {(valueDocType?.label === 'Health Document' ||
                      valueDocType?.label === 'Assessment' ||
                      valueDocType?.label === 'Misc Documents') && (
                      <>
                        <Col md="6">
                          <UploadFile
                            file={fileDoc}
                            setFile={setFileDoc}
                            handleRemove={handleRemoveDoc}
                          />
                        </Col>
                        <Col md="11" className="mt-2 mx-3">
                          <UploadMultiImages
                            file={files}
                            setFile={setFiles}
                            handleRemove={handleRemove}
                          />
                        </Col>
                      </>
                    )}
                  </div>
                  <div className="px-x1 border-top-0 mb-4">
                    <Button
                      variant="primary"
                      type="submit"
                      className="px-4 mx-0"
                    >
                      {loading ? 'Loading...' : 'Upload'}
                    </Button>
                    <Button
                      variant="secondary"
                      type="submit"
                      className="px-4 mx-2"
                      onClick={() => handleClose()}
                    >
                      Cancel
                    </Button>
                  </div>
                </Form>
              </div>
            ) : documentData?.length === 0 ? (
              <div className="m-3">
                <p>No Data Available</p>
              </div>
            ) : (
              <>
                <Card.Body className="p-0">
                  <AdvanceTable
                    headerClassName="bg-200 text-nowrap align-middle"
                    rowClassName="align-middle white-space-nowrap"
                    tableProps={{
                      size: 'sm',
                      striped: true,
                      className: 'fs-10 mb-0 overflow-hidden'
                    }}
                  />
                </Card.Body>
                <Card.Footer>
                  <div className="mt-3">
                    <AdvanceTableFooter
                      rowInfo
                      navButtons
                      rowsPerPageSelection
                    />
                  </div>
                </Card.Footer>
              </>
            )}
          </Card>
        </AdvanceTableProvider>
      )}
      <Modal
        size="lg"
        show={viewImgModel}
        keyboard={false}
        aria-labelledby="example-modal-sizes-title-lg"
        onHide={handleCloseView}
        contentClassName="border"
      >
        <Modal.Header
          closeButton
          className="bg-body-tertiary px-x1 border-bottom-0"
        >
          <Modal.Title as="h5"></Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-x1 text-center">
          <Image
            src={viewImg}
            style={{ maxWidth: '100%', maxHeight: '100%' }}
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

DocumentTable.propTypes = {
  documentData: PropTypes.any,
  nurseId: PropTypes.any,
  refresh: PropTypes.any,
  setRefresh: PropTypes.any
};

export default DocumentTable;
